const translations = {
  "en": {
    "Clipboard access denied": "Clipboard access denied",
    "Copied simplified version successfully": "Copied simplified version successfully",
    "Copy image": "Copy image",
    "Download": "Download",
    "Edgen": "Ed",
    "For more information, visit": "For more information, visit",
    "Image generation failed": "Image generation failed",
    "Share content reference not available": "Share content reference not available",
    "The picture %{var0} failed.": "The picture %{var0} failed.",
    "The picture was copy successfully.": "The picture was copy successfully.",
    "The picture was downloaded successfully.": "The picture was downloaded successfully.",
    "Your AI CIO": "Your AI CIO"
  },
  "zh-tw": {
    "Clipboard access denied": "剪貼簿存取遭拒",
    "Copied simplified version successfully": "簡化版本已複製",
    "Copy image": "複製圖片",
    "Download": "下載",
    "Edgen": "Ed",
    "For more information, visit": "如需更多資訊，請前往",
    "Image generation failed": "圖片產生失敗",
    "Share content reference not available": "無法存取分享內容",
    "The picture %{var0} failed.": "圖片 %{var0} 失敗。",
    "The picture was copy successfully.": "圖片複製成功。",
    "The picture was downloaded successfully.": "圖片下載成功。",
    "Your AI CIO": "你的 AI 投資長"
  }
};

export default translations;
